<template>
  <v-layout column wrap  style="overflow-y: auto;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <!-- <img :src="BASE_URL + 'static/icon/heart.svg'" alt="" width="40px"> &nbsp;&nbsp; -->
      <v-avatar size="40" style="background: #A80D00 !important;">
        <v-icon style="font-size: 24px; color: white !important;">fas fa-tools</v-icon>
      </v-avatar>
      &nbsp;&nbsp;
      <v-toolbar-title>แจ้งปัญหาการใช้งาน</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <span>สังกัดเครื่อง:</span>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
        <span>สถานะปัญหา:</span>
         <v-select
          :items="itemsselectStatus"
          v-model="selectKeyStatus"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
      </div>
    </v-toolbar>

    <div class="hidden-md-and-up">
        <span style="margin-top: 20px;">สังกัดเครื่อง:</span>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
        <br>
        <span style="margin-top: 20px;">สถานะปัญหา:</span>
         <v-select
          :items="itemsselectStatus"
          v-model="selectKeyStatus"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
      </div>

    <v-layout row wrap justify-center align-center style="margin-top: 20px;">
       <v-data-table
      :headers="headers"
      :items="listIssueFile"
      :items-per-page="10"
      class="elevation-1"
      @click:row="selectedDetailIssue"
      style="cursor: pointer;"
    >
    <template v-slot:item.issue_status="{ item }">
        <v-chip class="ma-2" small v-if="item.issue_status == 'open'">
          รอการยืนยันปัญหา
        </v-chip>
        <v-chip class="ma-2" small v-else-if="item.issue_status == 'confirm'" color="#ffddb1">
          รอการแก้ไข
        </v-chip>
        <v-chip class="ma-2" small v-else-if="item.issue_status == 'waiting_fix_confirm'" color="#fffabb">
          รอการยืนยันการแก้ไข
        </v-chip>
        <v-chip class="ma-2" small v-else-if="item.issue_status == 'close'" color="#c7e4b5">
          ได้รับการแก้ไขแล้ว
        </v-chip>

        <v-chip class="ma-2" small v-else>
          -
        </v-chip>
      </template> 
    <template v-slot:item.issue_detail="{ item }">
        {{item.issue_detail}}
      </template> 
      <template v-slot:item.company_name="{ item }">
        {{(item.company_name)? item.company_name:'-'}}
      </template>
      <template v-slot:item.create_at="{ item }">
        {{ dateMoment(item.create_at)}} - {{ timeMoment(item.create_at)}}น.
      </template>
    </v-data-table>
    </v-layout>
  </v-layout>
</template>
<script>
import { Decode, Momenttime } from '@/services'
var _ = require('lodash')
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    items: [],
    selectKey: 'all',
    selectKeyStatus: 'all',
    itemsselectStatus:  [
      { text: 'ทั้งหมด', value: 'all' },
      { text: 'เปิดปัญหา', value: 'open' },
      { text: 'ยืนยันปัญหา', value: 'confirm' },
      { text: 'รอการยืนยันการแก้ไข', value: 'waiting_fix_confirm' },
      { text: 'แก้ไขแล้ว', value: 'close' }
    ],
    itemsselect: [
      { text: 'ทั้งหมด', value: 'all' },
      { text: 'สภากาชาด', value: 'redcross' },
      { text: 'อื่นๆ', value: 'other' }
    ],
    search: '',
    headers: [
      { text: 'หัวข้อปัญหา', value: 'issue_detail' },
      { text: 'สถานที่', value: 'address_name' },
      { text: 'บริษัทเจ้าของ', value: 'company_name' },
      { text: 'สถานะปัญหา', value: 'issue_status' },
      { text: 'ผู้ที่แจ้งปัญหา', value: 'who_create_issue' },
      { text: 'วัน เวลา', value: 'create_at' }
    ],
    listIssue: [],
    authen: {},
    headerAPI: {}
  }},
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.getlistissue()
    if (this.$route.query.typeSearch == 'all' || this.$route.query.typeSearch == 'redcross' || this.$route.query.typeSearch == 'other') {
      this.selectKey = this.$route.query.typeSearch
    }
  },
  computed: {
    listIssueFile () {
      if (this.selectKeyStatus !== 'all') {
        return this.listIssueMode.filter(post => {
            return post.issue_status.toLowerCase().includes(this.selectKeyStatus.toLowerCase())
        })
      } else {
        return this.listIssueMode
      }
    },
    listIssueMode () {
      if (this.selectKey == 'redcross') {
        return this.listIssue.filter(post => {
          try {
            return post.company_type == 'owner'
          } catch(err) {
          }
        })
      } else if (this.selectKey == 'other') {
        return _.reject(this.listIssue, ['company_type', 'owner'])
      } else {
        return this.listIssue
      }
    }
  },
  methods: {
    selectedDetailIssue (item, row) {
      this.$router.push('/information_issue?id='+item.issue_id)
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    getlistissue () {
      this.axios.get(process.env.API_BACKEND + '/v1/getAllIssueAED', {headers: this.headerAPI}).then((response) => {
          this.listIssue = response.data.data
          this.listIssue = _.sortBy(this.listIssue, function(dateObj) {
            return new Date(dateObj.create_at)
          }).reverse()
      })

    }
    
  }
}
</script>
<style media="screen" scoped>
>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
}
>>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
    color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
>>>.v-list-item__title {
    line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}

/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}

>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}

.textfieldSelect {
  width: 150px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {

  .textfieldSelect {
    width: 80vw;
    /*margin-top: 20px;*/
    display: -webkit-inline-box;
    margin-right: 20px;
     border-radius: 30px !important;
    background: #ffffff !important;
    color: #a80e00 !important;
    border-color: #a80e00 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

}
/* >>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/listReport/Listissue.vue